import React, { Component } from 'react';
import { Redirect, Route, Link, Switch } from 'react-router-dom';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import Login from './StudentComponents/Auth/Login';
import SetNewPassword from './StudentComponents/Auth/SetNewPassword';
import ForgotPassword from './StudentComponents/Auth/ForgotPassword';
import Register from './StudentComponents/Auth/Register';
import ConfirmAccount from './StudentComponents/Auth/ConfirmAccount';


class StudentLogin extends Component {
    constructor(props)
    {
        super(props);



        this.state = {
          collapse: false,
          showError: false,
          loading: false,
          logged_in:true,
          access_token:"",
          user_details:{},

        };


    }


  render() {
      const _this=this;

      if(this.props.loginStatus)
      {
        return(<Redirect to="/student_ui"/>);
      }

    return (
      <div>
        <div className="wrapper wrapper-full-page">
        <div className="page-header login-page header-filter" filter-color="black">

          <div className="container">




            <div className="row">
              <div className="col-lg-5 col-md-6 col-sm-8 ml-auto mr-auto">
                <Switch>
                    <Route  exact path="/"
                            render={(props) => <Login {...props} base_url={_this.props.base_url}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      loginStatus = {_this.props.loginStatus}
                                                                      updateStudentDetails={_this.props.updateStudentDetails} />}
                    />
                    <Route  exact path="/student"
                            render={(props) => <Login {...props} base_url={_this.props.base_url}
                                                                      loginStatus = {_this.props.loginStatus}
                                                                      portal_base_url={_this.state.portal_base_url}
                                                                      updateStudentDetails={_this.props.updateStudentDetails} />}
                    />
                    <Route  exact path="/student/login"
                            render={(props) => <Login {...props} base_url={_this.props.base_url}
                                                                      loginStatus = {_this.props.loginStatus}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      updateStudentDetails={_this.props.updateStudentDetails} />}
                    />
                    <Route  exact path="/student/setnewpassword"
                            render={(props) => <SetNewPassword {...props} base_url={_this.props.base_url}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      updateStudentDetails={_this.props.updateStudentDetails} />}
                    />

                    <Route  exact path="/student/forgotpassword"
                            render={(props) => <ForgotPassword {...props} base_url={_this.props.base_url}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      updateStudentDetails={_this.props.updateStudentDetails} />}
                    />
                    <Route  exact path="/student/register"
                            render={(props) => <Register {...props} base_url={_this.props.base_url}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      updateStudentDetails={_this.props.updateStudentDetails} />}
                    />
                    <Route  exact path="/student/verifyaccount"
                            render={(props) => <ConfirmAccount {...props} base_url={_this.props.base_url}
                                                                      portal_base_url={_this.props.portal_base_url}
                                                                      updateStudentDetails={_this.props.updateStudentDetails} />}
                    />
                </Switch>



              </div>
            </div>
          </div>
          <footer className="footer">
            <div className="container">
              <nav className="float-left">
                <ul>
                  <li>
                    <Link to="https://www.tuc.ac.ke">
                      TURKANA UNIVERSITY COLLEGE
                    </Link>
                  </li>

                </ul>
              </nav>
              <div className="copyright float-right">

              </div>
            </div>
          </footer>
        </div>
      </div>

    </div>
    );
  }


}


export default StudentLogin;
